import React from 'react';
import './WhyUsPage.css';

import { PageTitle } from '../../../components';
import { Testimonials, WhyUs, Banner, Process, Skills, FAQs, Clients } from '../../../sections';



const WhyUsPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Why Choose Us'} page={'Why Choose Us'} />

      <section className='whyUs-page'>

        <WhyUs />
        <Testimonials />
        <Process />
        <Skills />
        <FAQs />
        <Banner />
        <Clients />

      </section>

    </>
  );
}

export default WhyUsPage;